import React, { Component } from "react";
import { Row, Col, Button, Form, FormGroup, Checkbox, ListGroup, ListGroupItem} from "react-bootstrap";

import './style.css';
import ClientService from '../../../services/client-service';

class NewClientForm extends Component{
  constructor(props){
    super(props);

    this.state = {
      isActive:true,
      pages:[],
      incident_live_nation:false,
      incident_standard:false
    };
  }

  onChangeActive = (e) =>{
    const isActive = e.target.checked;

    this.setState({ isActive });
  }

  onChangePageCheckbox = (e) =>{
    const {pages} = this.state;
    const {value,checked} = e.target;

    if(checked){
      pages.push(value);

      this.setState({ pages })
    }else{
      const index = pages.indexOf(value);

      if(index > -1){
        pages.splice(index,1);

        this.setState({ pages });
      }
    }
  }

  onChangeIncident = (e) =>{
    const {pages} = this.state;
    const {value,checked} = e.target;

    if(checked){
      if(pages.indexOf('Incidents') === -1){
        pages.push('Incidents');

        this.setState({ pages });
      }

      if(value === 'Live Nation'){
        this.setState({
          incident_standard:false,
          incident_live_nation:true
        });
      }else if(value === 'Standard'){
        this.setState({
          incident_standard:true,
          incident_live_nation:false
        });
      }
    }else{
      const index = pages.indexOf('Incidents');

      if(index > -1){
        pages.splice(index,1);

        this.setState({ pages });
      }

      if(value === 'Live Nation'){
        this.setState({ incident_live_nation:false });
      }else if(value === 'Standard'){
        this.setState({ incident_standard:false });
      }
    }
  }

  validateEmail = (email) =>{
    return (/\S+@\S+\.\S+/).test(email)
  }

  pagesToJson = (pages) =>{
    const refs = this.refs;
    const {incident_live_nation,incident_standard} = this.state;
    const txt_api = refs.txt_api.value;

    const permission = {};

    for(let x = 0 ; x < (pages).length; x++){
      const page = pages[x];

      if(page === 'Txt Commander'){
        permission[page] = txt_api;
      }else{
        permission[page] = 1;
      }
    }

    if(incident_live_nation || incident_standard){
      if(incident_live_nation){
        permission['Incidents'] = 'Live Nation';
      }else{
        permission['Incidents'] = 'Standard';
      }
    }

    return permission;
  }

  onSubmitForm = (e) =>{
    const form = e.target;

    e.preventDefault();

    const that = this;
    const refs = this.refs;
    const {pages,isActive} = this.state;

    const name = refs.name.value;
    const license = refs.license.value;
    const username = refs.username.value;
    const password = refs.password.value;
    const contact_name = refs.contact_name.value;
    const contact_phone = refs.contact_phone.value;
    const contact_email = refs.contact_email.value;
    
    if(name && license && contact_name && contact_phone && contact_email && username){
      if(pages.length){
        const isEmailValid = this.validateEmail(contact_email);

        if(!isEmailValid){
          return alert('Invalid email');
        }

        if(pages.indexOf('Txt Commander') > -1){
          const txt_api = refs.txt_api.value;

          if(!txt_api){
            return alert('API is required for Txt Commander');
          }
        }

        const permission = JSON.stringify(this.pagesToJson(pages));
        const param = {
          name,
          username,
          permission,
          contact_name,
          contact_phone,
          contact_email,
          status: (isActive ? 1 : 0),
          client_license: license
        }

        if(password) param.password = password

        ClientService.sharedInstance.newClient(param)
          .then(res => {
            if(res.success){
              form.reset();
              that.setState({
                isActive:true,
                incident_live_nation:false,
                incident_standard:false
              });

              that.props.notification.success('Client successfully created');
              that.props.onReloadData();
            }else{
              alert(res.message);
            }
          }).catch(err => {
            console.error('Error:',err);

            alert(err.message);
          });
      }else{
        alert('Please select atleast one permission');
      }
    }else{
      alert('Required fields: Username, Name, License, Contact Name, Contact Email and Contact Email');
    }
  }

  renderForm(){
    const {isActive,incident_live_nation,incident_standard} = this.state;

    return (  
      <div style={{padding:20}}>
        <Form onSubmit={this.onSubmitForm} ref={(el) => this.newClientForm = el}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <label className={'login_label'}>Username *</label>
                <input type='text' className='form-control' ref='username' defaultValue={'Archon'} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label className={'login_label'}>Password *</label>
                <input type='password' className='form-control' ref='password' defaultValue={'Archon'} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <label className={'login_label'}>Client Name *</label>
                <input type='text' className='form-control' ref='name' />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <label className={'login_label'}>License*</label>
                <input type='text' className='form-control' ref='license' />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <label></label>
                <Checkbox checked={isActive} onChange={this.onChangeActive}>Active</Checkbox>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <label className={'login_label'}>Contact Name *</label>
                <input type='text' className='form-control' ref='contact_name' />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <label className={'login_label'}>Contact Email *</label>
                <input type='text' className='form-control' ref='contact_email' />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <label className={'login_label'}>Contact Phone *</label>
                <input type='text' className='form-control' ref='contact_phone' />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <ListGroup className='page-list'>
                <ListGroupItem>
                  <Checkbox value='Dashboard' onChange={this.onChangePageCheckbox}>Dashboard</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Comm Log' onChange={this.onChangePageCheckbox}>Comm Log</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Dispatch' onChange={this.onChangePageCheckbox}>Dispatch</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Client Commander' onChange={this.onChangePageCheckbox}>Client Commander</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Assignments' onChange={this.onChangePageCheckbox}>Assignments</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Push Notifications' onChange={this.onChangePageCheckbox}>Push Notifications</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Tour Confirmation' onChange={this.onChangePageCheckbox}>Tour Confirmation</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Forms' onChange={this.onChangePageCheckbox}>Forms</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <span>Incidents</span>
                  <ListGroup id='incident-list' style={{marginLeft:20}}>
                    <ListGroupItem>
                      <Checkbox value='Standard' checked={incident_standard} onChange={this.onChangeIncident}>Standard</Checkbox>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Checkbox value='Live Nation' checked={incident_live_nation} onChange={this.onChangeIncident}>Live Nation</Checkbox>
                    </ListGroupItem>
                  </ListGroup>
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col md={6}>
              <ListGroup className='page-list'>
                <ListGroupItem>
                  <Checkbox value='Binder' onChange={this.onChangePageCheckbox}>Binder</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='e-Learning' onChange={this.onChangePageCheckbox}>e-Learning</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='HR Commander' onChange={this.onChangePageCheckbox}>HR Commander</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Row>
                    <Col md={4}>
                      <Checkbox value='Txt Commander' onChange={this.onChangePageCheckbox}>Txt Commander</Checkbox>
                    </Col>
                    <Col md={8}> 
                      <span>API</span> 
                      <input type='text' className='form-control txt-commander-api' ref='txt_api' />
                    </Col>
                  </Row>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Visitor Management' onChange={this.onChangePageCheckbox}>Visitor Management</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Activity Log' onChange={this.onChangePageCheckbox}>Activity Log</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Settings' onChange={this.onChangePageCheckbox}>Settings</Checkbox>
                </ListGroupItem>
                <ListGroupItem>
                  <Checkbox value='Reporting' onChange={this.onChangePageCheckbox}>Reporting</Checkbox>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{textAlign:'right'}}>
                <Button type='submit' className='btn green-btn'>Create Client</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }

  render(){
    return this.renderForm();
  }
}

export default NewClientForm;